import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { formatDate, Time } from "@angular/common";
import { Globals } from '../../../globals';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { IIepInstance } from '../../../Models/IIepInstance'
import { Message, SelectItem, SelectItemGroup } from 'primeng/primeng';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

/*------------------ user created components...  --------------------------------*/
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { ISPSDButtonControl } from 'src/app/Models/ISPSDButtonControl';
import { ILookupAttendancePeriodWeek } from 'src/app/Models/ILookupAttendancePeriodWeek';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { LookupService } from 'src/app/Services/LookupService';
import { SinglePageServiceDocumentationService } from 'src/app/Services/SinglePageServiceDocumentationService';
import { ServicesService } from '../../../Services/ServicesService';
import { IServiceLog } from '../../../Models/IServiceLog';
import { IServiceAssignment } from '../../../Models/IServiceAssignment';
import { IService } from '../../../Models/IService';


@Component({
  selector: 'SinglePageServiceDocumentation',
  templateUrl: './SinglePageServiceDocumentation.component.html',
  styleUrls: ['./SinglePageServiceDocumentation.component.css']
})


export class SinglePageServiceDocumentationComponent implements OnInit {

  private _baseUrl: string;

  //selectedServiceAssignmentId: string = "0";
  //selectedSchoolYearAttendancePeriod: string = "0";

  selectedStudentServiceAssignmentString: string;
  selectedAttendancePeriodString: string;
  selectedWeekNumberString: string;

  selectedStudentServiceAssignment: ILookupBase;
  selectedAttendancePeriod: ILookupBase;
  selectedWeekNumber: ILookupBase;
  serviceAssignment: IServiceAssignment;
  service: IService;

  selectedStartTime: string;
  selectedSessionStatus: string;
  selectedAbsenceCode: string;
  minutes: number;
  isMakeup: boolean;
  note: string;
  result: string;

  studentServiceList: ILookupBase[];
  attendancePeriodList: ILookupBase[];
  weekList: ILookupBase[];

  startTimeList: SelectItem[];
  lookupAbsenceCode: ILookupBase[];     //absenceCodeList: SelectItem[];
  lookupSessionStatus: ILookupBase[];   //sessionStatusList: SelectItem[];

  mon: ISPSDButtonControl;
  tue: ISPSDButtonControl;
  wed: ISPSDButtonControl;
  thu: ISPSDButtonControl;
  fri: ISPSDButtonControl;

  isSaveButtonVisible: boolean = false;
  messages: Message[]

  constructor
    (
      private globals: Globals,
      private _singlePageServiceDocumentationService: SinglePageServiceDocumentationService,
    private _lookupService: LookupService,
    private _servicesService: ServicesService,
    private _changeDetectorRef: ChangeDetectorRef,
      @Inject('BASE_URL') baseUrl: string) {
      this._baseUrl = baseUrl;
    }

  ngOnInit(): void {

    this.selectedStartTime = null;
    this.selectedSessionStatus = null;
    this.selectedAbsenceCode = null;
    

    this.selectedStudentServiceAssignmentString = null;
    this.selectedAttendancePeriodString = null;
    this.selectedWeekNumberString = null;

    this.LoadLookupValues();

    this.mon = {} as ISPSDButtonControl;
    this.tue = {} as ISPSDButtonControl;
    this.wed = {} as ISPSDButtonControl;
    this.thu = {} as ISPSDButtonControl;
    this.fri = {} as ISPSDButtonControl;

  }

  onServiceAssignmentChange(serviceAssignmentOption: ILookupBase) {
    this.selectedStudentServiceAssignment = serviceAssignmentOption;

    //get service information
    let serviceAssignmentId: number = Number(serviceAssignmentOption.value)
    if (!isNaN(serviceAssignmentId)) {
      this._servicesService.getServiceAssignment(serviceAssignmentId).subscribe(
        (assignment: IServiceAssignment) => {
          this.serviceAssignment = assignment

          this.setDefaultLogValues();
          
          //if additional service data is required initialize call to get service here
          this.getService();
          this.GetSelectedStudentServiceWeek();
        }
      )
    }
    

    this.GetSelectedStudentServiceWeek();
  }

  onAttendancePeriodChange(attendancePeriod: ILookupBase) {
    this.selectedAttendancePeriod = attendancePeriod;
    this.getAvailableWeeks();

    this.GetSelectedStudentServiceWeek();
  }

  SetWeekNumber(weekNumber: ILookupBase) {
    this.selectedWeekNumber = weekNumber;
    this.GetSelectedStudentServiceWeek();
  }

  getAvailableWeeks() {
    //determin attendance period
    let caretIndex = this.selectedAttendancePeriodString.indexOf('^');
    let schoolYear = this.selectedAttendancePeriodString.substring(0, caretIndex);
    let weekNumberString = this.selectedAttendancePeriodString.substring(caretIndex + 1);
    let weekNumber: number = Number(weekNumberString);

    this._singlePageServiceDocumentationService.getSPSDAttendancePeriodWeekList(schoolYear, weekNumber).subscribe(
      (res: ILookupBase[]) => {
        this.weekList = [{ label: '[Select Week]', value: null, shortText: '[Select Week]', updatedOn: null }].concat(res);
      },
      err => console.error(err)
    )
  }

  getService() {
    if (this.serviceAssignment && this.serviceAssignment.id && this.serviceAssignment.id > 0) {
      let serviceId = Number(this.serviceAssignment.serviceId)
      this._servicesService.getService(serviceId).subscribe(
        (ser: IService) => {
          this.service = ser;
        },
        (err) => {
          console.error(err);
          this.service = null;
        }
      )
    }
  }

  GetSelectedStudentServiceWeek() {
    if (this.selectedStudentServiceAssignmentString && this.selectedAttendancePeriodString && this.selectedWeekNumberString) {
      
      // todo - check to see if there are unsaved changes before fetching new data - warn/ask user whether to save changes

      this._singlePageServiceDocumentationService.getSPSDStudentServiceWeekList(this.selectedAttendancePeriod.value, this.selectedWeekNumber.value, this.selectedStudentServiceAssignment.value).
        subscribe((res: ISPSDButtonControl[]) => {
          this.mon = res[0];
          this.tue = res[1];
          this.wed = res[2];
          this.thu = res[3];
          this.fri = res[4];

          this.isSaveButtonVisible = true;

          this._changeDetectorRef.detectChanges();
        },
          err => {
            console.error(err);
            this.isSaveButtonVisible = false;
          }
        );
    }
    else { 
      // do nothing validation has failed
      this.isSaveButtonVisible = false;
    }
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [];
    this.messages = [...this.messages, msg];
  }

  buildServiceLog(serviceLogDate: Date) : IServiceLog {
    let startTimeString = this.selectedStartTime;
    let startDateTime = this.convertStringToTime(startTimeString, serviceLogDate);

    let endTimeDateTime = new Date(startDateTime);
    endTimeDateTime.setTime(endTimeDateTime.getTime() + this.minutes * 60000) // 60,000 miliseconds in a minute
    let endTimeString = endTimeDateTime.getHours() + ":" + endTimeDateTime.getMinutes();

    let absenceCode = parseInt(this.selectedAbsenceCode);

    let newServiceLog: IServiceLog = {
      id: 0,
      serviceAssignmentId: Number(this.selectedStudentServiceAssignmentString),
      dateOfService: serviceLogDate,
      startTime: startTimeString,
      endTime: endTimeString,
      sessionStatus: this.selectedSessionStatus,
      isMakeup: this.isMakeup,
      note: this.note,
      results: this.result,
      absenceCode: isNaN(absenceCode) ? null : absenceCode,
      updatedOn: new Date()
    }

    return newServiceLog;
  }

  clearMessages() {
    this.messages = [];
  }

  convertStringToTime(timeString: string, date?: Date) {
    let timeTokens: string[] = timeString.split(':');
    if (!isNaN(Number(timeTokens[0])) && !isNaN(Number(timeTokens[1]))) {
      let hour: number = 0;
      let minute: number = 0;
      let second: number = 0;
      if (timeTokens.length >= 1) {
        hour = Number(timeTokens[0]);
      }
      if (timeTokens.length >= 2) {
        minute = Number(timeTokens[1]);
      }
      if (timeTokens.length >= 3) {
        second = Number(timeTokens[2]);
      }

      if (date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, minute, second)
      }
      else {
        date = new Date();
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, minute, second)
      }

    }
    return null;
  }

  LoadLookupValues() {
    this._singlePageServiceDocumentationService.getSPSDAttendancePeriodList()
      .subscribe((res: ILookupBase[]) => {
        this.attendancePeriodList = [{ label: '[Select Period]', value: null, shortText: '[Select Period]', updatedOn: null }].concat(res);
      },
        err => console.error(err)
    );

    //default value until attendance period is selected
    this.weekList = [{ label: '[No Attendance Period Selected]', value: null, shortText: '[Select Week]', updatedOn: null }]

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SessionStatus])
      .subscribe((res: ILookupBase[]) => {
        this.lookupSessionStatus = [{ label: "[Select One]", value: null, shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.AbsenceCode])
      .subscribe((res: ILookupBase[]) => {
        this.lookupAbsenceCode = [{ label: "[Select One]", value: null, shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._singlePageServiceDocumentationService.getSPSDStudentServicesForProviderList()
      .subscribe((res: ILookupBase[]) => {
        this.studentServiceList = [{ label: '[Select Student/Service]', value: null, shortText: '[Select Student/Service]', updatedOn: null }].concat(res);
      },
        err => console.error(err)
    );

    this.startTimeList = [
      { label: '[Select Time]', value: null },
      { label: '8:00', value: '8:00' },
      { label: '8:05', value: '8:05' },
      { label: '8:10', value: '8:10' },
      { label: '8:15', value: '8:15' },
      { label: '8:20', value: '8:20' },
      { label: '8:25', value: '8:25' },
      { label: '8:30', value: '8:30' },
      { label: '8:35', value: '8:35' },
      { label: '8:40', value: '8:40' },
      { label: '8:45', value: '8:45' },
      { label: '8:50', value: '8:50' },
      { label: '8:55', value: '8:55' },

      { label: '9:00', value: '9:00' },
      { label: '9:05', value: '9:05' },
      { label: '9:10', value: '9:10' },
      { label: '9:15', value: '9:15' },
      { label: '9:20', value: '9:20' },
      { label: '9:25', value: '9:25' },
      { label: '9:30', value: '9:30' },
      { label: '9:35', value: '9:35' },
      { label: '9:40', value: '9:40' },
      { label: '9:45', value: '9:45' },
      { label: '9:50', value: '9:50' },
      { label: '9:55', value: '9:55' },

      { label: '10:00', value: '10:00' },
      { label: '10:05', value: '10:05' },
      { label: '10:10', value: '10:10' },
      { label: '10:15', value: '10:15' },
      { label: '10:20', value: '10:20' },
      { label: '10:25', value: '10:25' },
      { label: '10:30', value: '10:30' },
      { label: '10:35', value: '10:35' },
      { label: '10:40', value: '10:40' },
      { label: '10:45', value: '10:45' },
      { label: '10:50', value: '10:50' },
      { label: '10:55', value: '10:55' },

      { label: '11:00', value: '11:00' },
      { label: '11:05', value: '11:05' },
      { label: '11:10', value: '11:10' },
      { label: '11:15', value: '11:15' },
      { label: '11:20', value: '11:20' },
      { label: '11:25', value: '11:25' },
      { label: '11:30', value: '11:30' },
      { label: '11:35', value: '11:35' },
      { label: '11:40', value: '11:40' },
      { label: '11:45', value: '11:45' },
      { label: '11:50', value: '11:50' },
      { label: '11:55', value: '11:55' },

      { label: '12:00', value: '12:00' },
      { label: '12:05', value: '12:05' },
      { label: '12:10', value: '12:10' },
      { label: '12:15', value: '12:15' },
      { label: '12:20', value: '12:20' },
      { label: '12:25', value: '12:25' },
      { label: '12:30', value: '12:30' },
      { label: '12:35', value: '12:35' },
      { label: '12:40', value: '12:40' },
      { label: '12:45', value: '12:45' },
      { label: '12:50', value: '12:50' },
      { label: '12:55', value: '12:55' },

      { label: '1:00', value: '1:00' },
      { label: '1:05', value: '1:05' },
      { label: '1:10', value: '1:10' },
      { label: '1:15', value: '1:15' },
      { label: '1:20', value: '1:20' },
      { label: '1:25', value: '1:25' },
      { label: '1:30', value: '1:30' },
      { label: '1:35', value: '1:35' },
      { label: '1:40', value: '1:40' },
      { label: '1:45', value: '1:45' },
      { label: '1:50', value: '1:50' },
      { label: '1:55', value: '1:55' },

      { label: '2:00', value: '2:00' },
      { label: '2:05', value: '2:05' },
      { label: '2:10', value: '2:10' },
      { label: '2:15', value: '2:15' },
      { label: '2:20', value: '2:20' },
      { label: '2:25', value: '2:25' },
      { label: '2:30', value: '2:30' },
      { label: '2:35', value: '2:35' },
      { label: '2:40', value: '2:40' },
      { label: '2:45', value: '2:45' },
      { label: '2:50', value: '2:50' },
      { label: '2:55', value: '2:55' }
    ];

  }

  setDefaultLogValues() {
    let durationString = this.serviceAssignment.durationName
    let minuteSubstring = durationString.substring(0, durationString.indexOf(' '));
    let minuteValue = Number(minuteSubstring);
    if (!isNaN(minuteValue)) {
      this.minutes = minuteValue;
    }

    this.selectedSessionStatus = "Completed";
    this.selectedAbsenceCode = null;
    this.isMakeup = false;
    this.note = '';
    this.result = '';
  }

  validateServiceLogForm(): boolean {
    let isValid: boolean = true;

    if (this.selectedStartTime == null || this.selectedStartTime == undefined) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Start Time is required'
      };
      this.addMessage(errorMessage);
      isValid = false;
    }

    if (!this.minutes) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Minutes are required'
      };
      this.addMessage(errorMessage);
      isValid = false;
    }
    else {
      if (this.minutes < 0) {
        let errorMessage: Message = {
          severity: 'error', summary: 'Validation Error', detail: 'Minutes cannot be negative'
        };
        this.addMessage(errorMessage);
        isValid = false;
      }

      if (this.minutes > 900) {
        let errorMessage: Message = {
          severity: 'error', summary: 'Validation Error', detail: 'Minutes cannot be larger than 900 for a single log'
        };
        this.addMessage(errorMessage);
        isValid = false;
      }
    }

    if (this.selectedSessionStatus == "Cancelled" && this.selectedAbsenceCode == null) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Absence Code is required if session was cancelled'
      };
      this.addMessage(errorMessage);
      isValid = false;
    }

    return isValid;
  }

  onAbsenceCodeChange() {
    if (this.selectedAbsenceCode === "Cancelled") {
      this.minutes = 0;
    }
  }

  onSaveButtonClicked(settings: ISPSDButtonControl) {
    settings.isDisabled = true;
    this.clearMessages();

    if (this.validateServiceLogForm()) {
      //get button specific data
      let serviceLogDateString = settings.calendarDate;
      let serviceLogId = settings.serviceLogId;

      let serviceLogDate = new Date(serviceLogDateString);
      let serviceLog: IServiceLog = this.buildServiceLog(serviceLogDate);


      this._servicesService.insertUpdateServiceLog(serviceLog).subscribe((res: IServiceLog) => {
        let successMessage: Message = {
          severity: 'success', summary: 'Record Saved Successfully',
          detail: res.id.toString()
        }
        //adjust button to reflect new status
        settings.icon = "pi pi-check";
        settings.isDisabled = true;
        settings.serviceLogId = res.id;
      },
        err => {
          console.error(err);
          settings.isDisabled = false;
        }
      );
    }
    else {
      //error messages will be displayed by calling validate method
      settings.isDisabled = false;
    }
    
  }
}

